<template>
  <div class="new-home-wrapper">
    <!-- 实验 B C D组 -->
    <template
      v-if="
        isPlatform('zz') &&
        !getQueryString('saleCombineIds') &&
        dataInfo.pics &&
        dataInfo.pics.length
      "
    >
      <div>
        <img
          v-if="collected"
          class="first-pic"
          :class="{
            'luxury-first-pic': handleCollectAnimation
          }"
          :src="$setPicSize(dataInfo.pics[0])"
          alt=""
          @animationend="collected = false"
        />
        <img
          v-if="carted"
          class="cart-pic new-cart-pic"
          :src="$setPicSize(dataInfo.pics[0])"
          alt=""
          @animationend="carted = false"
        />
      </div>
    </template>
    <!-- 机型讲解 浮窗 -->
    <model-explanation v-if="dataInfo.videoModelSolution" :dataInfo="dataInfo" />
    <Skeleton v-show="needShowSkeleton"></Skeleton>
    <Loading v-if="needShowLoading" class="loading" color="#ff5555" size="45px" vertical></Loading>
    <!-- 将first page中的内容与接口返回的状态进行剥离，以便尽快加载DOM-->
    <div id="tab-prod" class="first-page">
      <new-header
        v-if="getQueryString('infoId')"
        :statusHeight="statusHeight"
        :baseInfoMsg="baseInfoMsg"
        :moreInfoMsg="moreInfoMsg"
        :collectAnimationEnd="collected == false"
        :cartAnimationEnd="carted == false"
        :carted="carted"
        :feedbackData="feedbackData"
        @listenLike="
          $refs.FooterRef &&
            $refs.FooterRef.like({ cancelAnimationFrame: true, sectionId: '99', sortId: '1' })
        "
      >
      </new-header>

      <Banner
        :statusHeight="statusHeight"
        :baseInfoMsg="baseInfoMsg"
        :moreInfoMsg="moreInfoMsg"
        :dataInfo="dataInfo"
        @listenMatching="listenMatching"
      ></Banner>

      <!-- 商品信息区域 新版 -->
      <product-base-info
        :dataInfo="dataInfo"
        :baseInfoMsg="baseInfoMsg"
        :visibilityState="visibilityState"
        :feedbackData="feedbackData"
        @updataList="updataList"
        @openPopupWarchPedia="openPopupWarchPedia"
      ></product-base-info>

      <!-- 性价比解读 -->
      <cost-performance
        ref="costRef"
        style="display: none"
        :costPerformanceExplain="{
          ...dataInfo.costPerformanceExplain,
          handPricePremiumContent,
          productName: dataInfo.title,
          showFeedback: true,
          feedbackData
        }"
        @costPerformanceBuy="
          getQueryString('saleCombineIds')
            ? $refs.FooterRef && $refs.FooterRef.saleCombineClick()
            : $refs.FooterRef && $refs.FooterRef.beforeBuy()
        "
      />
      <!-- 促销 & 活动 & 流程 收官项目实验组 -->
      <activityInfoCom
        ref="activityRef"
        :dataInfo="dataInfo"
        @cmpMounted="onCmpMounted"
        @listenPersuade="(data) => persuadeTipsRef && persuadeTipsRef.togglePopup(data)"
      />

      <sales-return-dialog ref="saleReturnRef" :dataInfo="dataInfo" />
    </div>

    <!-- 加载第二屏的内容 -->
    <div v-if="needShowSecondPage" class="second-page">
      <!-- 暂定B为改版样式 -->
      <section class="root">
        <!-- 门店模块 -->
        <store-block
          v-if="
            moreInfoMsg && moreInfoMsg.offlineStore && Object.keys(moreInfoMsg.offlineStore).length
          "
          :storeBlock="{ ...moreInfoMsg.offlineStore, cityId: moreInfoMsg.cityId }"
        ></store-block>

        <!-- 验机报告 -->
        <div class="report-content" v-if="dataInfo.infoType === 1000 && isShowReprot">
          <template>
            <zz-new-report
              id="tab-qcreport"
              :Infos="{
                ...dataInfo,
                pageId: 'T2974',
                cateId: stateInfo.cateFirstId,
                infoId: getQueryString('infoId') || stateInfo.infoId
              }"
              :warehouseInfo="baseInfoMsg.deliveryInfo.warehouseInfo || ''"
              :visibilityState="visibilityState"
              :showFeedback="true"
              :feedbackData="feedbackData"
              :planIds="
                (stateInfo.joinCalRealPriceRedPlans &&
                  stateInfo.joinCalRealPriceRedPlans.join(',')) ||
                ''
              "
            />
          </template>
        </div>
        <!-- 鉴定报告 -->
        <luxury-report
          id="tab-qcreport"
          :feedbackData="feedbackData"
          :goodsInfo="{
            ...dataInfo,
            showRedHubPicture: moreInfoMsg.showRedHubPicture
          }"
          :infoLv="baseInfoMsg.infoLv"
          :picList="baseInfoMsg.pics"
          :warehouseInfo="
            (baseInfoMsg.deliveryInfo && baseInfoMsg.deliveryInfo.warehouseInfo) || ''
          "
          :infoId="getQueryString('infoId')"
          :cateId="String(stateInfo.cateFirstId)"
          @onOpenGradePopup="onOpenGradePopup"
          @openPopupWarchPedia="openPopupWarchPedia"
          :isGoodsDetail="true"
          v-if="dataInfo.infoType != 1000 && moreInfoMsg.luxuryReport"
        />
        <!-- 腕表百科模块 二奢融合需求  v-if="moreInfoMsg.wikiInfo" -->
        <watchPedia
          @openWatchPopup="openWatchPopup"
          :dataInfo="dataInfo"
          :moreInfoMsg="moreInfoMsg"
        />

        <!-- 官方验流程 收官项目实验组 -->
        <qualityProcessCom :dataInfo="dataInfo" :feedbackData="feedbackData" />

        <!-- 收官需求 成色定级标准模块 -->
        <finenessStandardCom :dataInfo="dataInfo" />
        <!-- 卖家信息 -->
        <SellerInfoNew
          :sellerInfo="dataInfo.sellerInfo"
          :dataInfo="dataInfo"
          :saleCombineIds="getQueryString('saleCombineIds') || stateInfo.packageId"
        ></SellerInfoNew>

        <!-- 品牌馆 -->
        <brandPavilion
          id="tab-detail"
          :modelBrandInfo="dataInfo.modelBrandInfo || {}"
          :dataInfo="dataInfo"
          :saleCombineIds="getQueryString('saleCombineIds') || stateInfo.packageId"
        />

        <!-- 二奢商品介绍 -->
        <GoodsIntro
          v-if="baseInfoMsg.wearingInfo"
          id="tab-goodsIntro"
          :dataInfo="{
            ...dataInfo,
            statusHeight
          }"
          scene="mainPage"
          :eventBus="{}"
        ></GoodsIntro>

        <!-- 收官项目合并同款评价、种草秀列表 展示 -->
        <productDetailEvalInfo ref="zcshowRef" :feedbackData="feedbackData" :dataInfo="dataInfo" />

        <!-- 同款推荐 搭售商详不展示此模块 -->
        <new-similar-products
          v-if="!getQueryString('saleCombineIds') && !stateInfo.packageId"
          :dataInfo="dataInfo"
          :upgradeStyle="stateInfo.upgradeStyle"
          :feedbackData="feedbackData"
          :hideSameStyleRec="dataInfo.hideSameStyleRec"
        ></new-similar-products>
        <!--碳排放 CarbonEmission -->
        <CarbonEmissionCom :dataInfo="dataInfo" />

        <!-- 问题 -->
        <!-- <questionCom :dataInfo="dataInfo" :feedbackData="feedbackData" /> -->
        <!-- 掌机游戏模块 -->
        <protable-game
          v-if="dataInfo.gameAccountNumberBusinessVo"
          :gameAccountNumberBusinessVo="dataInfo.gameAccountNumberBusinessVo"
        ></protable-game>
        <!-- 好货推荐 搭售商详不展示此模块 -->
        <recommend
          v-if="!getQueryString('saleCombineIds') && !stateInfo.packageId"
          id="tab-recommend"
          :feedbackData="feedbackData"
        ></recommend>
        <!-- 新人红包 -->
        <new-user-coupon
          v-if="dataInfo.newUserCouponPendant"
          :newUserCouponPendant="dataInfo.newUserCouponPendant"
          :installmentInfo="dataInfo.installmentInfo"
          @updataList="updataList"
        ></new-user-coupon>
        <!-- 新人券挂件 -->
        <coupon-tips v-if="getQueryString('financeFrom') == 'financeShop'"></coupon-tips>
        <!-- 用户触达红包弹窗 -->
        <coupon-dialog
          v-if="cardInfo && cardInfo.cardType"
          v-bind="{ ...cardInfo, sysType: getSysType() }"
          pageId="T2974"
          @receiveCoupon="receiveCoupon"
          @dialogClose="dialogClose"
        />
        <!-- 底部按钮 -->
        <footer-block
          ref="FooterRef"
          :dataInfo="dataInfo"
          @listenPersuade="(data) => persuadeTipsRef && persuadeTipsRef.togglePopup(data)"
          @callBmFunction="callBmFunction"
          @listenMatching="listenMatching"
          @collected="changeCollect"
          @cartStatus="changeCart"
        ></footer-block>
        <persuadeTips
          ref="persuadeTipsRef"
          @listenPersuade="$refs.FooterRef.buy()"
          @callBmFunction="callBmFunction"
        />
        <MatchingSales
          ref="matchingRef"
          :idsData="idsData"
          :matchingSaleAb="'B'"
          :infoId="getQueryString('infoId') || stateInfo.infoId"
          :whetherShowPosteriorQcStyle="stateInfo.whetherShowPosteriorQcStyle"
          :planIds="stateInfo.joinCalRealPriceRedPlans"
          platform="zz"
        />
      </section>
    </div>
    <popupWarchPedia ref="refPopupWarchPedia" :dataInfo="dataInfo" />
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  computed,
  reactive,
  ref,
  Ref,
  toRefs,
  provide,
  nextTick
} from '@vue/composition-api'
import { getSysType } from '@utils/ua'
import { Actions, setState, state as stateInfo } from '@/store/index'
import { Loading } from '@zz-common/zz-ui'
import Skeleton from './components/skeleton/index.vue'
import { url, cookie } from '@zz-common/zz-utils'

import {
  getQueryString,
  getUrlParams,
  toParams,
  copy,
  loadFirstImage,
  getCookie,
  loadJS
} from '@utils/index'
import {
  getStatusBarHeight,
  setStatusBarDarkMode,
  nativeGetCookie,
  getUserLengthOfStay,
  isPlatform,
  pageOnHide,
  pageOnShow,
  setWebViewPageId,
  nativeGetStorage,
  isLogin,
  skipToUrl
} from '@utils/native'
import { BaseInfo } from '@/model/baseInfo'
import { MoreInfo } from '@/model/moreInfo'
import { ReportItem } from '@/model/moreinfoResp'
// TIPS: 以下为首屏展示组件，通过同步引用的方式全部打入app.js chunk中，以便在第一时间执行

import newHeader from './components/commonHeader/index.vue'
import Banner from './components/banner/index.vue'
import ProductBaseInfo from './components/newProductBaseInfo/index.vue'
import activityInfoCom from './components/newActivityInfo/index.vue'
import CostPerformance from './components/CostPerformance/index.vue'
import SalesReturnDialog from './components/salesReturnDialog/index.vue'
import ModelExplanation from './components/modelExplanation/index.vue'

// TIPS: 质检报告组件同步引入
// import { ZzNewReport } from '@zz-yp/b2c-ui'

// import { ZzNewReport } from '@zz-yp/b2c-ui'

import ZzNewReport from '@zz-yp/b2c-ui/src/zz-new-report'
import LuxuryReport from '@zz-yp/b2c-ui/src/zz-luxury-quality-report'

import { LegoPerformance, legoInit } from '@zz-common/lego'
import {
  prerenderMonitor,
  transmitParamSearch,
  getInfoDetailBubbleSceneConfigInfo,
  getInfoDetailBubbleShowInfo,
  getProductDetailEvalInfo
} from '@/apis/index'
import native from '@zz-common/native-adapter'

// TIPS: 将第二屏的组件，打入同一个文件中，以减少请求数量

// TIPS: 异步加载红包弹窗组件
const CouponDialog = async () => {
  require('@zz-yp/b2c-ui/lib/coupon-dialog/style.css')
  return await import(/* webpackChunkName: "coupon-dialog" */ '@zz-yp/b2c-ui/src/coupon-dialog')
}

// $ 搭售组件
const MatchingSales = async () => {
  require('@zz-yp/b2c-ui/lib/matching-sales/style.css')
  return await import(/* webpackChunkName: "coupon-dialog" */ '@zz-yp/b2c-ui/src/matching-sales')
}

const Recommend = () =>
  import(/* webpackChunkName: "second-page" */ './components/recommend/index.vue')
// 新人优惠券弹窗
const NewUserCoupon = () =>
  import(/* webpackChunkName: "second-page" */ './components/newUserCoupon/index.vue')
const CouponTips = () =>
  import(/* webpackChunkName: "second-page" */ './components/couponTips/index.vue')
const FooterBlock = () =>
  import(/* webpackChunkName: "second-page" */ './components/footer/index.vue')

const NewSimilarProducts = () =>
  import(/* webpackChunkName: "second-page" */ './components/similarProducts/new.vue')

// $ 售后率过高文案组件
const persuadeTips = () =>
  import(/* webpackChunkName: "second-page" */ './components/persuadeTips/index.vue')

// 掌机游戏模块
const protableGame = () =>
  import(/* webpackChunkName: "second-page" */ './components/portableGame/index.vue')

// 收官项目 卖家信息模块 品牌馆 评价列表
const SellerInfoNew = () =>
  import(/* webpackChunkName: "second-page" */ './components/sellerInfo/index.vue')
const brandPavilion = () =>
  import(/* webpackChunkName: "second-page" */ './components/brandPavilion/index.vue')

// 评价 种草秀列表模块
const productDetailEvalInfo = () =>
  import(/* webpackChunkName: "second-page" */ './components/productDetailEvalInfo/index.vue')

// 碳中和模块
const CarbonEmissionCom = () =>
  import(/* webpackChunkName: "second-page" */ './components/carbonEmission/index.vue')

// const questionCom = () =>
//   import(/* webpackChunkName: "second-page" */ './components/question/index.vue')

// 收官需求 官方验模块
const qualityProcessCom = () =>
  import(/* webpackChunkName: "second-page" */ './components/qualityProcess/index.vue')
// 收官需求 成色定级标准模块
const finenessStandardCom = () =>
  import(/* webpackChunkName: "second-page" */ './components/finenessStandard/index.vue')

const storeBlock = () =>
  import(/* webpackChunkName: "second-page" */ './components/storeBlock/index.vue')

// TODO: 二奢融合 质检报告组件
// const LuxuryReport = () =>
//   import(/* webpackChunkName: "second-page" */ '@/components/LuxuryReport/Index.vue')

// TODO: 二奢融合 腕表百科弹窗
const popupWarchPedia = () =>
  import(/* webpackChunkName: "second-page" */ '@/components/popup-watch-pedia.vue')

// TODO: 二奢融合 增加腕表百科模块
const watchPedia = () =>
  import(/* webpackChunkName: "second-page" */ './components/watchPedia/index.vue')

// TODO: 二奢融合 增加商品介绍模块
const GoodsIntro = () =>
  import(/* webpackChunkName: "second-page" */ './components/GoodsIntro/index.vue')

export default defineComponent({
  name: 'Home',
  components: {
    ModelExplanation,
    storeBlock,
    CouponDialog,
    newHeader,
    Banner,
    ProductBaseInfo,
    Skeleton,
    Loading,
    CostPerformance,
    ZzNewReport,
    Recommend,
    FooterBlock,
    NewUserCoupon,
    CouponTips,
    NewSimilarProducts,
    persuadeTips, // 劝退文案组件
    MatchingSales, // 搭售商品组件
    SalesReturnDialog,
    protableGame,

    // 收官项目新组件
    activityInfoCom,
    SellerInfoNew,
    brandPavilion,
    productDetailEvalInfo,
    CarbonEmissionCom,
    // questionCom,
    qualityProcessCom,
    finenessStandardCom,
    watchPedia,
    LuxuryReport,
    popupWarchPedia,
    GoodsIntro
  },

  setup(props, ctx) {
    const { $tiktok, $legoInit, $legoSend } = ctx.root
    const cardInfo: Ref = ref({})
    const postId: Ref = ref()
    const dataReady: Ref = ref(false)
    const statusHeight: Ref = ref(0)
    const needShowSecondPage: Ref = ref(false)
    const needShowLoading: Ref = ref(false)
    const needShowSkeleton: Ref = ref(true)
    // 本次URL加载行为是否为'预加载'请求 1 是预加载请求 非1 不是预加载请求
    const isPreRender: Ref = ref(Boolean(getQueryString('isPreRender')))
    const zzPreRender = (window as any).zzPreRender || {}
    const visibilityState = ref('')
    const stayInfoId = ref('')
    const costRef: Ref<any> = ref(null) // 性价比弹窗 针对
    const saleReturnRef: Ref<any> = ref(null) // 退货包邮弹窗
    const persuadeTipsRef: Ref<any> = ref(null) // 劝退文案弹窗
    const activityRef: Ref<any> = ref(null) // 活动模块
    const idsData = ref({})
    const matchingRef: Ref<any> = ref(null) // 搭售组件弹窗
    const showMatching = ref(false) // 搭售组件
    const collected = ref<Boolean>(false) // 是否开启收藏动画
    const zcshowRef: Ref<any> = ref(null)
    const state: any = reactive({
      dataInfo: {
        pics: []
      }
    })
    const baseInfoMsg: any = ref({}) // baseInfo 接口返回的基础信息
    const moreInfoMsg: any = ref({}) // MoreInfo 接口返回的基础信息
    const abTest: Ref<string> = ref('A')
    const loadedEcharts = ref(false) // 是否加载过echarts

    const carted = ref(false) // 是否开启购物车动画

    interface PopupWarchPediaRef {
      togglePopup: (data) => void
    }
    const refPopupWarchPedia: Ref<PopupWarchPediaRef | null> = ref(null) // TODO: 二奢融合 百科弹窗模块
    $tiktok('start 进入并执行Home组件', 'HOME_PAGE_SHOW')
    setWebViewPageId({
      pageId: 'T2974'
    })

    /**
     * $ 打开腕表百科弹窗
     */
    // TODO: 二奢融合 打开腕表百科弹窗
    const openPopupWarchPedia = (data) => {
      const { checkId = '' } = moreInfoMsg.value?.wikiInfo?.popUpInfo
      console.log(data, '打开腕表百科弹窗', checkId)
      refPopupWarchPedia?.value?.togglePopup(data || checkId)
    }

    /**
     * $ 打开官方验半层
     */
    const openWatchPopup = () => {
      const infoId = getQueryString('infoId') || state.infoId
      const targetUrl = `https://m.zhuanzhuan.com/u/micro_detail/watchPopup?needHideHead=3&wvCornerRadius=36&wvHalfVer=v2&wvHeightRate=0.8&infoId=${infoId}&productType=watch`
      skipToUrl({
        targetUrl
      })
    }

    // 获取收藏气泡配置
    const getBubbleConfig = async (
      infoId = '',
      firstRender = false,
      infoDetailCollectedAB = 'C'
    ) => {
      const res = await getInfoDetailBubbleSceneConfigInfo()
      const bubbleDelayCallTimeList = res?.data?.infoDetailBubbleDelayCallTimeList || []
      if (!bubbleDelayCallTimeList.length) return
      const list = firstRender
        ? bubbleDelayCallTimeList.filter((item) => item.scene !== 'returnInfoDetail')
        : bubbleDelayCallTimeList
      for (const { scene, delayCallTime } of list) {
        setTimeout(() => {
          getBubbleInfo(scene, infoDetailCollectedAB, infoId)
        }, delayCallTime)
      }
    }

    // 获取收藏气泡信息
    const getBubbleInfo = async (scene, infoDetailCollectedAB, infoId) => {
      const res = await getInfoDetailBubbleShowInfo({
        scene,
        infoDetailCollectedAB,
        infoId
      })
      if (res?.data?.bubbleInfo) {
        setState({
          bubbleInfo: res?.data?.bubbleInfo
        })
      }
    }

    /**
     * $ 触发收藏动画
     */
    const changeCollect = (v) => {
      collected.value = v
    }

    /**
     * $ 触发购物车动画 实验C以外共用一个动画 避免重复动画
     * @param { boolean } status
     */
    const changeCart = (status) => {
      carted.value = status
    }

    // $ 触达红包弹窗关闭埋点上报
    const dialogClose = () => {
      const compose = cardInfo.value.cardType == 2
      $legoSend({
        pagetype: 'clickClose',
        actiontype: 'T2974',
        backup: {
          sortname: compose ? '叠加券弹窗关闭' : 'OCD红包弹窗关闭',
          sectionId: 10006,
          sortid: 0,
          postId: postId.value,
          ...(compose ? {} : { isOcd: 1 })
        }
      })
    }

    // $ 触达红包领取埋点上报
    const receiveCoupon = ({ planId = '', buttonText = '' } = {}) => {
      const compose = cardInfo.value.cardType == 2
      /* eslint-disable */
      $legoSend({
        pagetype: 'PopupClick',
        actiontype: 'T2974',
        backup: {
          sectionId: 10006,
          sortName: buttonText,
          popupname: compose ? '叠加券红包弹窗' : 'OCD红包弹窗',
          sortId: 0,
          postId: postId.value,
          ...(compose
            ? {}
            : {
                isOcd: 1,
                ...(planId.includes('&') ? { redIdList: planId } : { redId: planId })
              })
        }
      })
    }
    /* eslint-enable */

    // rstmark是进入页面生成的一个毫秒时间戳，如果滑动分页浏览，参数不变，只有刷新整个页面或者重新进入这个页面，才会重新更新，商品曝光埋点使用
    localStorage.setItem('rstmark', new Date().getTime().toString())
    /**
     * @description: 获取顶状态栏的状态
     * @param {*}
     * @return {*}
     */
    const handleStatusBar: Function = () => {
      getStatusBarHeight({}, (res) => {
        statusHeight.value = Number(res.pixelHeight) / window.devicePixelRatio
      })
      setStatusBarDarkMode({
        dark: 1
      })
    }

    function treeFindPath(tree, func, path: any[] = []) {
      if (!tree) return []
      for (const data of tree) {
        path.push(data.itemId)
        if (func(data)) return path
        if (data.children) {
          const findChildren = treeFindPath(data.children, func, path)
          if (findChildren.length) return findChildren
        }
        path.pop()
      }
      return []
    }

    /**
     * $ 递归遍历获取瑕疵图
     * @param {*} objectTree 遍历的对象
     * @param {*} childrenName 递归的属性名
     * @param {*} targetTree 递归的目标对象
     * @param {*} targetNode 递归的目标对象里面的目标值
     * @param {*} detailDrawing 目标值存储的数组
     * @return {*}
     */
    const collectAllFlawedImg = (
      originTree: any[],
      childrenName: string,
      targetTree: string,
      targetNode: string,
      detailDrawing: string[] = [],
      collection: string[] = [],
      valueIds: string[] = [],
      detailDrawingNewObj: any[] = []
    ) => {
      originTree.forEach((item) => {
        if (item[targetTree]) {
          item[targetTree].forEach((z) => {
            if (!z.notShowDetail) {
              const sItem =
                item.standardDefines &&
                item.standardDefines.length &&
                item.standardDefines.find((sItem) => sItem.qcItemName === z.value) // 获取当前百科数据 客户端预览大图需要用到此数据
              const flawDesc = sItem && sItem.defineDesc && sItem.defineDesc[0]
              // 单瑕疵图多拍
              // 以下是瑕疵图的逻辑
              if (z[targetNode] && z[targetNode].length > 0) {
                z[targetNode].forEach((img) => {
                  collection.push(item.itemId)
                  valueIds.push(z.valueId)
                  // 瑕疵图压缩图
                  detailDrawing.push(img.imgUrl)
                  detailDrawingNewObj.push({
                    flawTitle: `${item.firstTitle}-${item.name}-${z.value}`,
                    flawDesc: flawDesc || '',
                    url: img.origImgUrl // 瑕疵图原图
                  })
                })
              }
            }
          })
          return
        }
        if (item[childrenName]) {
          collectAllFlawedImg(
            item[childrenName],
            childrenName,
            targetTree,
            targetNode,
            detailDrawing,
            collection,
            valueIds,
            detailDrawingNewObj
          )
        }
      })
    }

    /**
     * @description: 页面数据初始化函数
     * @param {*} void
     * @return {*}
     */
    let flag = false

    // $ 收官项目查询评价种草秀列表数据
    const getDetailEvalInfo = async () => {
      const { data } = await getProductDetailEvalInfo({
        infoId: stateInfo.infoId || getQueryString('infoId'),
        pageIndex: 1,
        pageSize: 10
        // orderBy:
      })
      setState({
        evalListData: data.evalList,
        zcShowListData: data.zcShowList,
        rating: (data.rating && [...data.rating, { i: 1 }]) || {
          i: Math.floor(Math.random() * 100)
        }
      })
    }

    const getPageData: Function = (): void => {
      // $ 搭售商品
      if (getQueryString('saleCombineIds')) {
        setState({ saleCombineIds: getQueryString('saleCombineIds') })
      }
      //初始商品信息
      Actions.getGoodsInfoList()
        .then((res: BaseInfo): void => {
          if (res) {
            setState({
              abMap: res.abMap || {}, // ab实验分组
              initCollected: res.collected, // 是否收藏
              collectionCount: res.collectionCount || 0, // 收藏数量
              initCartStatus: Boolean(res?.cartInfo?.status),
              cartInfoNum: res.cartInfo?.num || 0,
              //  +res.officialVerifyUnifyAB || 0
              upgradeStyle: +res.officialVerifyUnifyAB || 0
            })
            if (!flag) {
              flag = true
              if (res.toLower !== true) {
                getBubbleConfig(getQueryString('infoId'), true) // 获取收藏气泡配置
                pageOnShow({}, () => {
                  getBubbleConfig(getQueryString('infoId'), false)
                })
              }
            }

            // 类目第三级类目id存起来
            const cateFirstId = res?.cateLastId
            if (cateFirstId) {
              setState({
                cateFirstId
              })
            }

            const brandId = res?.brandId

            if (brandId) {
              setState({
                brandId
              })
            }

            // 预加载第一张轮播图
            const fisrtImage = (res && res.pics && res.pics[0]) || ''
            loadFirstImage(fisrtImage)
            // 渐进式加载轮播图首图
            loadFirstImage(fisrtImage, 250, 250)
            dataReady.value = true
            needShowSkeleton.value = false
            hideLoading()
            state.dataInfo = copy(Object.assign({}, state.dataInfo, res))
            console.log(state.dataInfo, 'dataInfo')

            // 新字段， 用来标识baseInfo接口返回的信息
            baseInfoMsg.value = res
            console.log(baseInfoMsg, 'baseInfoMsg')

            idsData.value = {
              cateId: res.cateLastId,
              brandId: res.brandId,
              modelId: res.modelId
            }
            legoInit.setUserBackup({
              handPricePremium: state.dataInfo.handPriceVo?.handPricePremium || '0'
            })
            // 存储业务线
            // 1000:代表的是一机一拍  1:红布林 2:后验 3: 入仓 4: 回收入仓
            if (res.infoType) {
              setState({
                infoType: res.infoType
              })
            }
            if (res.abContent) {
              $legoSend('ab_event', { ABContent: JSON.parse(res.abContent) })
            }
            if (res.deliveryInfo) {
              setState({
                addressJson: {
                  province: (res.deliveryInfo as any).sendAddress || ''
                }
              })

              setState({
                whetherShowPosteriorQcStyle:
                  (res.deliveryInfo as any).whetherShowPosteriorQcStyle || 0
              })
            }

            // 判断是否有自动领券的红包
            if (res.joinCalRealPriceRedPlans) {
              console.log('res.joinCalRealPriceRedPlans', res.joinCalRealPriceRedPlans)
              setState({
                joinCalRealPriceRedPlans: res.joinCalRealPriceRedPlans
              })
            } else {
              setState({
                joinCalRealPriceRedPlans: []
              })
            }
            // 获取种草秀和评价数据，待重构
            getDetailEvalInfo()
            if (res.productDetailDsBtn) {
              $legoSend('Areaexposure', {
                sectionId: 143,
                sortName: '搭售'
              })
            }
            console.log('test code for coverage  111')
          }
        })
        .catch((e) => console.log(e))

      Actions.getMoreInfoList()
        .then((res: MoreInfo) => {
          if (res) {
            legoInit.setUserBackup({
              handPricePremium: state.dataInfo.handPriceVo?.handPricePremium || '0'
            })
            if (res.abContent) {
              $legoSend('ab_event', { ABContent: JSON.parse(res.abContent) })
            }
            const reportItem: ReportItem[] = res?.report?.reportItem
            const detailDrawing: string[] = [] // $ 细节图
            const detailDrawingNewObj = [] // $ 存放客户端大图预览的细节图对象
            const collectArr = []
            const valueIds = []
            //质检码存起来
            const qcCode = res?.report?.qcCode || ''
            if (qcCode) {
              setState({
                qcCode
              })
            }

            // 配件信息
            const accessoryList = res?.report?.accessoryList || []
            if (accessoryList.length) {
              setState({
                accessoryList
              })
            }

            if (reportItem) {
              reportItem.forEach((originTreeItem, originTreeIdex) => {
                if (originTreeItem.children) {
                  console.log(originTreeIdex, originTreeItem.children)
                  originTreeItem.children.forEach((mapItem) => {
                    mapItem.children &&
                      mapItem.children.forEach((zItem) => {
                        zItem.firstTitle = mapItem.name || ''
                      })
                  })
                }
              })
              collectAllFlawedImg(
                reportItem,
                'children',
                'values',
                'flawedImgVo',
                detailDrawing,
                collectArr,
                valueIds,
                detailDrawingNewObj
              )
            }
            if (detailDrawing.length) {
              // 预加载第一张瑕疵图
              loadFirstImage(detailDrawing[0])
            }
            //收集细节图对应的一二三级质检项id
            const collectObj = {}
            if (collectArr.length) {
              for (let i = 0; i < collectArr.length; i++) {
                collectObj[i] = treeFindPath(reportItem, (data) => data.itemId == collectArr[i])
                collectObj[i].push(valueIds[i])
                collectObj[i].shift()
              }
            }
            // MoreInfoMsg接口字段返回
            moreInfoMsg.value = Object.assign(
              res,
              { detailDrawing },
              { detailDrawingNewObj },
              { detailDrawingIds: collectObj }
            )

            state.dataInfo = copy(
              Object.assign(
                {},
                state.dataInfo,
                res || {},
                { detailDrawing },
                { detailDrawingNewObj },
                { detailDrawingIds: collectObj }
                // { featureLabels: ['堪比新机', '屏幕完美', '电池健康90%+', '电池健康90%+'] }
              )
            )

            //退货包邮信息在moreinfo 接口中返回
            showSalesReturnDialog()
            // 加载echarts
            loadEcharts()
          }
        })
        .catch((e) => console.log(e))
    }

    /**
     * @description: 初始化zpm
     * @param {*}
     * @return {*}
     */
    const initZPM: Function = () => {
      const pagequery = getUrlParams(window.location.href)
      const isshare = getQueryString('isshare')
      const infoId = getQueryString('infoId')
      const metric = getQueryString('metric')
      const shareuid = getQueryString('shareuid')
      const fromInstallment = getQueryString('fromInstallment')
      const cemHashKey = getQueryString('cemHashKey')
      delete pagequery.tt
      delete pagequery.refpagequery
      delete pagequery._zpm
      delete pagequery.needHideHead
      const query = toParams(pagequery)
      $legoInit({
        pagetype: 'CommodityDetail',
        pagequery: query,
        isshare: isshare ? '1' : '0', // 0否 1是
        shareuid,
        fromInstallment,
        infoId,
        metric,
        newStyle: 'new',
        cemHashKey
      })
    }

    /**
     * @description: 页面loading动画处理函数
     * @param {*} void
     * @return {*}
     */
    const handleLoading: Function = (): void => {
      setTimeout(() => {
        if (!dataReady.value) {
          showLoading()
        }
      }, 500) // 从用户进入页面到500毫秒之后决定是否显示loading动画，这500毫秒是留给接口请求的
    }

    /**
     * @description: 展示loading动画
     * @param {*} void
     * @return {*}
     */
    const showLoading: Function = (): void => {
      needShowLoading.value = true
    }

    /**
     * @description: 关闭loading动画
     * @param {*} void
     * @return {*}
     */
    const hideLoading: Function = (): void => {
      if (needShowLoading.value) {
        needShowLoading.value = false
      }
    }

    /**
     * @description: 刷新页面数据
     * @param {*}
     * @return {*}
     */
    const updataList = () => {
      getPageData()
    }

    /**
     * @description: 监听页面显示
     * @param {*}
     * @return {*}
     */
    const pageShowEvent: Function = () => {
      setTimeout(() => {
        document.addEventListener('visibilitychange', monitorPageShow)
        // 增加200毫秒的延迟，目的是为了防止 document.visibilityState在invokeJs_viewWillAppear时值为hidden，导致后面增加无谓的getPageData请求。200毫秒，足以让invokeJs_viewWillAppear中的document.visibilityState值从hidden切换为visible
      }, 200)
    }

    // 旧机换新半弹层关闭以后，要重新获取商详以旧换新卡片数据(转转侧两端均无法触发document.hidden的变化)，所以监听缓存的变化
    const listenStorageChange: Function = () => {
      window.addEventListener('storage', (e) => {
        storageChange(e)
      })
    }

    const storageChange: Function = (e) => {
      if (e.key == 'close-half-time') {
        getPageData()
      }
    }
    //发送参数给搜推
    const sendParamToSearch = async () => {
      await transmitParamSearch({
        pageId: 'T2974',
        infoId: getQueryString('infoId') || stateInfo.infoId
      })
    }
    //用户首次进入弹退货包邮弹窗
    const showSalesReturnDialog: Function = () => {
      const afterSalesServiceModule = state.dataInfo.afterSalesService || {}
      const { tipBannerPic = '' } = afterSalesServiceModule
      const SalesReturnStatus = localStorage.getItem('SalesReturnStatus')
      //如果未返回退货包邮数据或者弹窗已经弹过则不弹退货包邮的弹窗，继而执行红包触达场景的逻辑
      if (!tipBannerPic || SalesReturnStatus) {
        // getTouchInfo()
      } else {
        nextTick(() => {
          saleReturnRef.value.showSalesReturnPop = true
          localStorage.setItem('SalesReturnStatus', '1')
        })
      }
    }

    // 用户页面停留时长统计
    pageOnShow({}, () => {
      localStorage.setItem('start_view', String(new Date().getTime()))
    })

    //微信小程序兼容，页面展现获取地址上面的 addressId, 先暂时调用wx的sdk， 等金鑫修复，统一收拢到adapter中
    if (isPlatform('wa')) {
      native.initWxConfig(() => {
        ;(window as any).zzwa &&
          (window as any).zzwa.onShow(() => {
            const addressId = url.getHashParam('zzwa_address') || url.getHashParam('m-user-address')
            if (addressId) {
              setState({
                addressId
              })
            }
          })
      })
    }

    pageOnHide({}, () => {
      getUserLengthOfStay()
    })

    /**
     * @description: 页面显示回调函数
     * @param {*}
     * @return {*}
     */
    const monitorPageShow = () => {
      // 保存当前页面是否展示的状态
      visibilityState.value = document.visibilityState
      if (!document.hidden) {
        setTimeout(() => {
          getPageData()
          // zcshowRef.value.getDetailEvalInfo()
          //屎山代码，待后端重构接口
        }, 700)
        //更新进入时间
        // localStorage.setItem('start_view', String(new Date().getTime()))
        // nativeLogin({
        //   callback: (res) => {
        //     if (res.code == 0) {
        //       setTimeout(() => {
        //         getPageData()
        //       }, 700)
        //     }
        //   },
        // })
      }
    }

    const loadEcharts = () => {
      if (loadedEcharts.value) {
        return
      }
      loadJS('https://s1.zhuanstatic.com/common/u/echarts.min.js', () => {
        console.log('echarts 加载完成')
        loadedEcharts.value = true
      })
    }

    const initData = () => {
      if (!isPreRender.value) {
        handleLoading()
        getPageData()
        prerenderMonitor('not_prerender_pv')
      }
    }

    const initAfterPageMounted = async (isFromPreRender) => {
      $legoSend('VIEW_MOUNTED', { isFromPreRender: isFromPreRender ? '1' : '0' }) // 上报页面mounted的次数埋点
      pageShowEvent()
      handleStatusBar()
      initZPM() //初始化zpm上报
      listenStorageChange()
      sendParamToSearch()
      // 获取用户的登录状态
      setState({
        isLogin: isLogin()
      })
      //没有命中预渲染的时候
      // if (!isFromPreRender) {
      //   // 使用客户端缓存的图片资源
      //   const infoId = getQueryString('infoId')
      //   let cacheData: any = await nativeGetStorage('feed-goods-cache')
      //   if (cacheData) {
      //     cacheData = JSON.parse(cacheData)
      //     cacheData.forEach((item) => {
      //       if (item.infoId == infoId) {
      //         loadFirstImage(item.imgurl)
      //         console.log('图片资源命中缓存')
      //         state.dataInfo.pics = [item.imgurl]
      //       }
      //     })
      //   }
      // }
    }

    const invokeNative_log = (info) => {
      const _info = `[ZLJRENDER][DEBUG][H5] ${info}`
      console.warn(_info)
      try {
        zzPreRender.log(_info)
      } catch (e) {
        console.warn('调用invokeNative_log出错:', e)
      }
    }

    const invokeJs_viewWillAppear = (message) => {
      try {
        // 所有的数据都是被包裹在detail键里的
        let { jumpUrl } = (message && message.detail) || {}
        if (!jumpUrl) {
          invokeNative_log('异常：没有获得jumpUrl')
          return
        }

        const infoId = getQueryString('infoId', jumpUrl)
        const metric = getQueryString('metric', jumpUrl)
        const orderId = getQueryString('orderId', jumpUrl)
        const quickStart = getQueryString('quickStart', jumpUrl)
        const fromInstallment = getQueryString('fromInstallment', jumpUrl)
        const saleCombineIds = getQueryString('saleCombineIds', jumpUrl) // 搭售商品
        const packageId = getQueryString('packageId', jumpUrl) // 搭售商品

        // 后验逻辑客服需要的参数
        const version = getQueryString('version', jumpUrl)
        const t = getQueryString('t', jumpUrl)
        const ip = getQueryString('ip', jumpUrl)
        const uid = getQueryString('uid', jumpUrl)
        const initFrom = getQueryString('init_from', jumpUrl)
        if (infoId) {
          //从缓存中读取数据，用于渲染轮播图首图
          nativeGetStorage('feed-goods-cache', (cacheData) => {
            if (cacheData) {
              cacheData = JSON.parse(cacheData)
              if (Array.isArray(cacheData)) {
                cacheData.forEach((item) => {
                  if (item.infoId == infoId) {
                    console.info('图片资源命中缓存')
                    loadFirstImage(item.imgurl)
                    baseInfoMsg.value = {
                      ...baseInfoMsg.value,
                      pics: [item.imgurl]
                    }
                  }
                })
              }
            }
          })

          setState({ infoId })
          stayInfoId.value = infoId
        }
        if (orderId) {
          setState({ orderId })
        }
        if (metric) {
          setState({ metric })
        }
        if (quickStart) {
          setState({ quickStart })
        }
        if (fromInstallment) {
          setState({ fromInstallment })
        }

        // $ 搭售商品
        if (saleCombineIds) {
          setState({ saleCombineIds })
        }

        if (version) {
          setState({ version })
        }
        if (t) {
          setState({ t })
        }
        if (ip) {
          setState({ ip })
        }

        if (uid) {
          setState({ uid })
        }

        if (initFrom) {
          setState({ initFrom })
        }

        if (packageId) {
          setState({ packageId })
        }

        // 重要：修改本地location.href的值,方便其它业务使用，并且保障location.href与实际页面一致
        // 兼容处理离线包场景（离线包可能导致url的scheme为http而不是https）
        jumpUrl = jumpUrl.replace(/^https?:(.*)/, (m, p) => p)
        window.history.replaceState(null, '', jumpUrl)

        // 如果客户端给h5页面传了nextPageData，说明h5页面可以快速显示一部分内容，所以此事要将骨架屏隐藏
        // if (nextPageData) {
        //   // 要对nextPageData进行url解码
        //   this.detailInfo = JSON.parse(decodeURIComponent(nextPageData))
        //   const { titleInfoModule = {} } = this.detailInfo
        //   // 设置商品标题
        //   this.$bus.$emit('setProductName', titleInfoModule.productName || '')
        //   this.hideSkeleton = true
        // } else {
        //   this.invokeNative_log(`没有获取到nextPageData`)
        // }

        // invokeNative_log(`viewWillAppear 计划显示的 infoId: ${getQueryString('infoId')}`)

        handleLoading()
        //微商详点击领券取消登陆，然后快速进入商详，如果这时候命中预渲染，cookie中会没有tk值，这样会影响baseinfo接口返回新人红包的信息
        // app之后会发版处理，h5这边暂时先使用sdk从native中获取tk并写入webview的cookie
        if (!cookie.get('tk')) {
          nativeGetCookie({}, (res) => {
            if (res.code == 0) {
              const tk = getCookie('tk', res.cookie)
              cookie.set('tk', tk, {
                path: '/',
                domain: 'zhuanzhuan.com'
              })
              getPageData()
            }
          })
        } else {
          getPageData()
        }
        initAfterPageMounted(true)
        prerenderMonitor('prerender_pv')
        setTimeout(() => {
          new LegoPerformance()
            .set({ isprerender: 1, blankTime: 1, fmp: 100, atfTime: 100, loadTime: 100 })
            .send()
        }, 100)
      } catch (error) {
        prerenderMonitor('view_will_appear_err_count')
        // page_type: VIEW_WLL_APPEAR_ERROR    action_type: T2974
        $legoSend('VIEW_WLL_APPEAR_ERROR', { error_message: error.message })
        // 将错误往客户端层抛，以便客户端方便对页面进行降级
        throw error
      }
    }

    const registerWebViewLifeCycle = () => {
      zzPreRender.onViewWillAppear = invokeJs_viewWillAppear
    }

    // 通知客户端，预渲染的页面创建完成
    const invokeNative_pageCreated = () => {
      needShowSkeleton.value = false
      zzPreRender?.viewCreated(location.href)
    }

    initData()
    /**
     * @description: 页面mounted生命周期执行函数
     * @param {*}
     * @return {*}
     */
    provide('listenClickTab', () => costRef.value.$refs.cost.costPerfHandle())
    onMounted(() => {
      if (!isPreRender.value) {
        // 小程序页面显示回调， 主要是配送栏切换地址
        // addEventListenerWeChartPageShow()
        initAfterPageMounted(false)
      } else {
        registerWebViewLifeCycle()
        // 如果本次请求是一次预渲染，则执行完mounted时，给客户端一个通知
        invokeNative_pageCreated()
      }
    })

    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', monitorPageShow)
      document.removeEventListener('storage', listenStorageChange())
    })

    const onCmpMounted = () => {
      needShowSecondPage.value = true // 开始加载第二屏
      needShowSkeleton.value = false // 隐藏骨架屏
      $tiktok('======第一屏最后一个组件显示出来', '======')
    }

    //平台反馈入口传参数据统一处理
    const feedbackData = computed(() => {
      return {
        pgCateId: state.dataInfo.cateLastId,
        infoIds: getQueryString('infoId') || stateInfo.infoId,
        infoName: state.dataInfo.title,
        quality: state.dataInfo.infoLv?.level,
        price: state.dataInfo?.handPriceVo?.handPriceCent / 100,
        qcOrderId: stateInfo.qcCode
      }
    })

    const isShowReprot = computed(() => {
      return Boolean(state.dataInfo.report && state.dataInfo.infoLv)
    })

    // $ 溢价文案
    const handPricePremiumContent = computed(() => {
      return (
        state.dataInfo?.costPerformanceExplain?.premiumTipContent ||
        state.dataInfo.handPriceVo?.handPricePremiumContent ||
        ''
      )
    })

    const computedInfoId = computed(() => {
      return getQueryString('infoId') || stateInfo.infoId
    })

    // $ 搭售按钮点击事件
    const listenMatching = (tabname, index) => {
      if (tabname) {
        matchingRef.value?.getMatchingSales(index, tabname)
        // setTimeout(() => {
        //   matchingRef.value.tabClickHandle(tabname, index)
        // }, 500)
      } else {
        matchingRef.value?.getMatchingSales()
      }
    }

    // 租机入口不显示，收藏动画处理
    const handleCollectAnimation = computed(() => {
      return baseInfoMsg.value.infoType != 1000 || moreInfoMsg.value?.leaseVo?.topButton == 0
    })

    //以旧换新弹窗方法调用给c2b自己控制
    const callBmFunction = () => {
      activityRef.value &&
        activityRef.value.$refs.oldRef &&
        activityRef.value.$refs.oldRef.goRecycle()
    }

    //等级面板桥接事件
    const onOpenGradePopup = () => {
      console.log('onOpenGradePopup')
      // basicInfoRef.value.showPanel()
    }

    return {
      ...toRefs(state),
      isPlatform,
      collected,
      changeCollect,
      stateInfo,
      visibilityState,
      statusHeight,
      dataReady,
      getQueryString,
      updataList,
      onCmpMounted,
      needShowSecondPage,
      needShowLoading,
      needShowSkeleton,
      isPreRender,
      isShowReprot,
      costRef, // $ 性价比弹窗
      handPricePremiumContent, // 溢价文案内容
      persuadeTipsRef, // 溢价文案组件
      activityRef,
      saleReturnRef, // 退货包邮弹窗
      cardInfo,
      getSysType,
      showMatching,
      idsData,
      matchingRef,
      listenMatching,
      computedInfoId,
      dialogClose,
      receiveCoupon,
      callBmFunction,
      feedbackData,
      carted, // 购物车状态
      changeCart,
      zcshowRef,

      // 收官项目
      abTest,
      baseInfoMsg,
      moreInfoMsg,
      onOpenGradePopup,
      refPopupWarchPedia,
      openPopupWarchPedia,
      handleCollectAnimation,
      openWatchPopup
    }
  }
})
</script>

<style lang="scss" scoped>
@mixin select-touch {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

@keyframes newcollect {
  from {
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(0.1);
    opacity: 0.6;
  }
  to {
    transform: translate(-27vw, -140vw) scale(0.07);
    opacity: 0.8;
  }
}

@keyframes newcart {
  from {
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(0.1);
    opacity: 0.6;
  }
  to {
    transform: translate(-9vw, -140vw) scale(0.07);
    opacity: 0.8;
  }
}

@keyframes luxurycollect {
  from {
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(0.1);
    opacity: 0.6;
  }
  to {
    transform: translate(-18vw, -140vw) scale(0.07);
    opacity: 0.8;
  }
}

@keyframes cart {
  from {
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(0.1);
    opacity: 0.6;
  }
  to {
    transform: translate(-28.5vw, -140vw) scale(0.07);
    opacity: 0.8;
  }
}

.new-home-wrapper {
  background-color: #ffffff;
  /deep/.b2c-new-report-wrapper .qc-report {
    padding-top: 0;
    padding-bottom: 68px;
  }
  .first-pic {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 10000;
    width: 100vw;
    min-height: 750px;
    border-radius: 50%;
    animation: newcollect 1s ease-in-out;
    &.luxury-first-pic {
      animation: luxurycollect 1s ease-in-out;
    }
  }
  .cart-pic {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 10000;
    width: 100vw;
    min-height: 750px;
    border-radius: 50%;
    animation: cart 1s ease-in-out;
    &.new-cart-pic {
      animation: newcart 1s ease-in-out;
    }
  }
}
.first-page {
  min-height: 80vh;
  .banner-wrap {
    @include select-touch;
  }
  .promotion-wrapper {
    @include select-touch;
  }
  .cost_popup {
    @include select-touch;
  }
  .activity-wrapper {
    @include select-touch;
  }

  .cache-img {
    width: 750px;
    height: 750px;
  }
}
.second-page {
  .report-content {
    min-height: 750px;
    // margin-top: 68px;
    .ab-upgradeStyle {
      margin-bottom: 64px;
    }
  }
  .root {
    .seller-wrapper {
      @include select-touch;
    }
    .evaluate_wrapper {
      @include select-touch;
    }
    .carbon-wrapper {
      @include select-touch;
    }
    .similar-wrapper {
      @include select-touch;
    }
    .product-detail {
      @include select-touch;
    }
    .faq-wrap {
      @include select-touch;
    }
    .recommend-wrapper {
      @include select-touch;
    }
    .text-scroll {
      @include select-touch;
    }
  }
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%);
}
</style>
